// extracted by mini-css-extract-plugin
module.exports =  {"content":"_93444fe79c--content--jJhx0"};